<template>
  <div class="flex-table-queue">
    <div class="flex-table-queue__wrapper" :class="currentLayout">
      <header class="flex-table-queue__header" :class="{'hidden': hiddenHeader || showLogoFullScreen}">
        <div class="flex-table-queue__logo">
          <img :src="logo" class="logo-img" alt="logo">
        </div>
        <div class="flex-table-queue__speaker">
          <PlayList/>
        </div>
      </header>

      <main class="flex-table-queue__main" >
        <template v-if="trySetClient">
          <template v-if="!loadingDataError">

            <TicketList
              v-if="!clientsEmpty"
              class="flex-table-queue__ticket-list"
              ref="ticketList"
            >
              <TicketListItem
                class="flex-table-queue__ticket-list-item"
                v-for="(ticket, index) in currentTickets"
                queue-ticket-list-item-hook
                :key="`ticket-list-item-${index}-${ticket.id}`"
              >
                <TicketSimple
                  queue-ticket-hook
                  :queue-ticket-label-hook="ticket.seatLabel"
                  :queue-ticket-number-hook="ticket.ticketNumber"
                  :queue-ticket-title-hook="ticket.title"
                  :item="ticket"
                >
                  <template #seatLabel="{ item }">
                    <span>{{ getFormattedSeatLabel(item) }}</span>
                  </template>
                </TicketSimple>
              </TicketListItem>
            </TicketList>

            <LogoEmpty v-show="showLogoFullScreen" class="flex-table-queue__logo-fullscreen"/>

            <AdPlayList
              v-if="showAdv"
              class="flex-table-queue__adv"
              :play-list-items="raifPlaylistOrientation"
              :full-screen="false"
            />
          </template>

          <template v-else>
            <div class="flex-table-queue__error-description">
              <template v-if="accessDeniedError">
                <Loader queue-table-error-title-hook class="flex-table-queue__error-reconnect" queue-table-loader-hook>
                  {{$t('error.accessDenied1')}}
                </Loader>
                <div queue-table-error-desc-hook class="flex-table-queue__error-authorization" v-html="$t('error.accessDenied2')"></div>
              </template>
              <template v-else>
                <div queue-table-error-title-hook class="flex-table-queue__error-loading">
                  {{ $t('error.loading') }}
                </div>
                <div queue-table-error-desc-hook class="flex-table-queue__error-connection">
                  {{$t('common.makeConnection')}}
                </div>
              </template>
            </div>
          </template>
        </template>

        <div v-else class="flex-table-queue__loader">
          <Loader queue-table-loader-hook>Загрузка</Loader>
        </div>
      </main>
    </div>

    <AdPlayListAudio
      v-if="playlistsAudioItemsNotEmpty"
      class="flex-table-queue__audio"
      :play-list-audio-items="playlistsAudioItems"
    />
  </div>
</template>

<script>
import TableQueueController from '@/views/table/queue/table-queue-controller'
import ResizeLoggerMixin from '@/app/mixins/resize-logger-mixin'

// components
import { layouts } from '@/app/const/settings'
import PlayList from '@/components/playlist/PlayList'
import AdPlayList from '@/components/playlist/AdPlayList'
import LogoEmpty from '@/components/logos/LogoEmpty'
import Loader from '@/components/loaders/Loader'
import TicketListItem from '@/components/tickets/TicketListItem'
import TicketList from '@/components/tickets/TicketList'
import TicketSimple from '@/components/tickets/ticket-simple/TicketSimple'
import AdPlayListAudio from '@/components/playlist/AdPlayListAudio'
import ScreenStateIdTypes from '@/components/tickets/model/screen-state-id-types'
import ClientStateIdTypes from '@/components/tickets/model/client-state-id-types'

export default {
  name: 'RaifTableQueue',
  mixins: [TableQueueController, ResizeLoggerMixin],
  components: {
    TicketList,
    TicketListItem,
    TicketSimple,
    Loader,
    LogoEmpty,
    AdPlayList,
    PlayList,
    AdPlayListAudio
  },
  computed: {
    currentLayout () {
      return {
        'flex-table-queue--horizontal': this.layout === layouts.colAd,
        'flex-table-queue--vertical': this.layout === layouts.col1Ad
      }
    },
    raifPlaylistOrientation () {
      if (this.layout === layouts.col1Ad) {
        return this.playlistMainItems.filter(item => item.isVerticalOrientation())
      }
      if (this.layout === layouts.colAd) {
        return this.playlistMainItems.filter(item => item.isHorizontalOrientation())
      }

      return this.playlistMainItems
    }
  },
  methods: {
    getFormattedSeatLabel ({ screenStateId, clientStateId, seatLabel }) {
      if (ScreenStateIdTypes.isInQueue(screenStateId)) {
        return ''
      }

      if (ClientStateIdTypes.isRejection(clientStateId)) {
        return '-'
      }

      return seatLabel
    }
  }
}
</script>

<style lang="stylus">

.flex-table-queue {
  flex 1
  display flex
  font-size 60px

  &__wrapper {
    flex 1
    display flex
    flex-direction column
  }

  &__main {
    flex 1
    display flex
    flex-direction column
  }

  &__header {
    display flex
    flex-direction column
    justify-content center
    align-items center
    min-height 3em

    &.hidden {
      display none
    }
  }

  &__logo {
    padding 1em 0
    width fit-content
    height fit-content
    img {
      height 1.5em
      width 1.5em
    }
  }

  &__logo-fullscreen {
    display flex
    justify-content center
    align-items center
    flex 1
    font-size 1em

    .icon-empty {
      &__wrapper {
        height 100%

        .elem .raif-left svg {
          width 3em
          height auto
        }
        .elem .raif-right svg {
          width 7.2em
          height auto
        }
      }
    }
  }

  &__speaker {
    position absolute
    top 50px
    right 50px
  }

  &__audio {
    position fixed
    top 15px
    left 15px
  }

  &__ticket-list {
    display flex
    flex-direction column
    gap 0.5em
    flex 1
    margin 0 1.5em 0.5em
  }

  &__ticket-list-item {
    &::before {
      background-color transparent
    }
  }

  &__adv {
    position relative
    display flex
    width 100%
    height 100vh
    flex 1 auto
  }

  &__loader {
    margin auto
    .loader {
      font-size 0.5em
    }
  }

  &__error {
    &-description {
      font-size 0.5em
      flex 1
      display flex
      flex-direction column
      align-items center
      padding-top 5vh
      line-height normal
    }
    &-reconnect {
      font-size 1em
    }
    &-authorization {
      font-size 0.8em
    }
    &-loading {
      font-weight 500
    }
    &-connection {
      font-weight 300
    }
  }

  .ticket-simple {
    font-size 1em
  }

  &--vertical {
    .add-contents {
      height fit-content
      width 100%
      flex 0 1 auto

      .content {
        flex-direction inherit
        height fit-content
        flex 1

        .vertical {
          width 100%
          height fit-content
        }

        .horizontal {
          object-fit cover
          height 100vh
        }
      }
    }

    @media (orientation: portrait) {
      @media (min-height: 2560px) {
        font-size 85px
      }

      @media (min-height: 3840px) {
        font-size 120px
      }
    }
  }

  &--horizontal {
    font-size 70px

    .flex-table-queue {
      &__wrapper {
        flex-direction row-reverse
      }

      &__main {
        flex-direction row-reverse
      }

      &__header {
        display none
      }

      &__ticket-list {
        min-width 17vw
        margin 1em
        gap 0.55em
      }

      &__logo-fullscreen {
        flex 33%
        height 100vh
      }
    }

    .icon-empty .raif-right {
      display none
    }

    .icon-empty .raif .icon-empty__wrapper {
      gap 0
    }

    .add-contents {
      .content {
        height 100%
        .horizontal {
          object-fit fill
          height 100vh
        }

        .vertical {
          width 100%
          object-fit cover
        }
      }
    }

    //@media
    @media (orientation: landscape) {
      @media (min-width: 2560px) {
        font-size 90px
        .flex-table-queue__ticket-list {
          gap 0.85em
        }
      }

      @media (min-width: 3840px) {
        font-size 120px
        .flex-table-queue__ticket-list {
          gap 0.85em
        }
      }
    }
  }

  .ticket-simple__number-item span,
  .ticket-simple__window-item span {
    font-size: 60px; /* fallback — безопасный дефолт */
  }

  /* FULL HD – Горизонтальная */
  @media screen and (width: 1920px) and (height: 1080px) and (orientation: landscape) {
    .ticket-simple__number-item span,
    .ticket-simple__window-item span {
      font-size: 90px;
    }
  }

  /* FULL HD – Вертикальная */
  @media screen and (width: 1080px) and (height: 1920px) and (orientation: portrait) {
    .ticket-simple__number-item span,
    .ticket-simple__window-item span {
      font-size: 75px;
    }
  }

  /* 2K – Горизонтальная */
  @media screen and (width: 2560px) and (height: 1440px) and (orientation: landscape) {
    .ticket-simple__number-item span,
    .ticket-simple__window-item span {
      font-size: 100px;
    }
  }

  /* 2K – Вертикальная */
  @media screen and (width: 1440px) and (height: 2560px) and (orientation: portrait) {
    .ticket-simple__number-item span,
    .ticket-simple__window-item span {
      font-size: 95px;
    }
  }

  /* 4K – Горизонтальная */
  @media screen and (width: 3840px) and (height: 2160px) and (orientation: landscape) {
    .ticket-simple__number-item span,
    .ticket-simple__window-item span {
      font-size: 140px;
    }
  }

  /* 4K – Вертикальная */
  @media screen and (width: 2160px) and (height: 3840px) and (orientation: portrait) {
    .ticket-simple__number-item span,
    .ticket-simple__window-item span {
      font-size: 120px;
    }
  }
  /* 4K DCI – Горизонтальная */
  @media screen and (width: 4096px) and (height: 2160px) and (orientation: landscape) {
    .ticket-simple__number-item span,
    .ticket-simple__window-item span {
      font-size: 140px;
    }
  }

  /* 4K DCI – Вертикальная */
  @media screen and (width: 2160px) and (height: 4096px) and (orientation: portrait) {
    .ticket-simple__number-item span,
    .ticket-simple__window-item span {
      font-size: 120px;
    }
  }
}
</style>
